import React, { useState } from "react";
import { Link } from "react-router-dom";
import Request from "./../weigthscale/request";
import { request } from "./../queue/datalist";
const Requestall = () => {
    const [isOpen, setisOpen] = useState(false);
    const [list, setList] = useState([ ]);
   
    const handleCancle = () => {
      setisOpen(false);
    };
    const handleonClickclose = (event) => {
      setList(false);
    };
    const handleonClikisopen = (event) => {
      setisOpen(true);
    };
  return (
    <>
      <Request
        onCancel={handleCancle}
        list={list}
        isOpen={isOpen}
        
      />
      <div className="container-fluid">
        <div className="card-shadow">
          <div className="card-body d-flex justify-content-center">
            <span className="fs-2 fw-bold text-primary">
              <i className="bi bi-pencil-square fs-3 me-3"></i>แจ้งงานเพิ่มเติม
            </span>
          </div>
        </div>
     
          <div className="row col-lg-2 col-md-3 col-sm-5  m-1 my-3">
            <button 
            className="btn btn-primary fs-6" 
            type="button"
            onClick={() => handleonClikisopen()}>
              <i className="bi bi-plus-lg fs-6 me-3"></i> ADD NEW
            </button>
          </div>
     
        {request &&
          request.length > 0 &&
          request.map((item, index) => (
            <div
              className="card shadow  mt-2 border-top-0 border-start border-primary border-end-0 border-bottom-0 border border-2"
              key={index}
            >
              <div className="row m-2">
                <div className=" col-lg-2 mt-2 ">
                  <span className="badge rounded-pill bg-primary mb-1">
                    {item.id}
                  </span>
                  <img
                    src={item.image}
                    className="rounded-circle ms-3"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title
                    style={{
                      width: "100%",
                      maxHeight: 40,
                      maxWidth: 40,
                      border: "none",
                    }}
                  />
                  <span className="badge text-primary fs-6">{item.name}</span>
                </div>

                <div className="col-lg-4">
                  <div>
                    <h6>
                      หัวข้องาน :
                      <small style={{ fontSize: 14 }}> {item.title}</small>
                    </h6>
                  </div>
                  <div>
                    <h6>
                      คำอธิบาย :
                      <small style={{ fontSize: 14 }}>
                        {" "}
                        {item.discription}
                      </small>
                    </h6>
                  </div>

                  <div />
                </div>
                <div className=" col-lg-2 ">
                  <h6 className="text-success ">
                    วันแจ้งงาน :
                    <small style={{ fontSize: 14 }}>
                      <span className="text-dark ms-2">{item.startdate}</span>
                    </small>
                  </h6>

                  <h6 className="text-danger">
                    กำหนดเสร็จ :
                    <small style={{ fontSize: 14 }}>
                      <span className="text-dark ms-2">{item.enddate}</span>
                    </small>
                  </h6>
                </div>

                <div className=" col-lg-2 ">
                  <div className="row ">
                    <span className="d-flex justify-content-start">
                      {" "}
                      รูปที่แนบมา :{" "}
                    </span>

                    <span className="d-flex justify-content-start ">
                      <i
                        className="bi bi-camera-fill me-2  fs-4 text-primary"
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        className="bi bi-camera-fill me-2 fs-4 text-primary"
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        className="bi bi-camera-fill me-2 fs-4 text-primary"
                        style={{ cursor: "pointer" }}
                      />
                      <i
                        className="bi bi-camera-fill me-2 fs-4 text-primary"
                        style={{ cursor: "pointer" }}
                      />
                    </span>
                  </div>
                </div>
                <div className="col-lg-2  d-flex align-items-center d-flex justify-content-end">
                  <i
                    //   onClick={() => handleonClikisopen()}
                    className="bi bi-trash me-4 text-danger"
                    style={{ fontSize: "25px", cursor: "pointer" }}
                  ></i>
                  <i
                    //   onClick={() => handleonClikisopen()}
                    className="bi bi-pencil-square me-2 text-info"
                    style={{ fontSize: "25px", cursor: "pointer" }}
                  ></i>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default Requestall;
